import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M145-146q-32 0-56-23-23-24-23-56v-510q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H145Zm0-79h451v-163H145v163Zm511 0h159v-386H656v386ZM145-448h451v-163H145v163Z"/>',
  f: '<path d="M145-146q-32 0-56-23-23-24-23-56v-510q0-33 23-56 24-24 56-24h670q33 0 56 24 24 23 24 56v510q0 32-24 56-23 23-56 23H145Zm0-79h451v-163H145v163Zm511 0h159v-386H656v386ZM145-448h451v-163H145v163Z"/>',
};

export default data;
